import _ from "lodash";
import { singular } from "../../../utils/stringUtils";

/**
 * @param authorizedActions Authorized actions of logged-in admin
 * @param resource Name of entity/resource to authorize the user against
 * @param action Name of the action to perform on the resource/entity, and also to authorize the user against,
 * could be null then we can verify only the resource
 *
 * @returns A boolean says if user is authorize to perform that action on that resource.
 */
export default (authorizedActions, resource, action = null) => {
    let authorized = false;
    _.keys(authorizedActions).forEach((key) => {
        if (singular(resource) === key) {
            if (action) {
                const actions = authorizedActions[`${key}`];
                authorized = _.includes(actions, action);
            } else {
                authorized = true;
            }
        }
    });
    return authorized;
};
